import { useState, useMemo, useEffect } from 'react';
import { SearchDropdown } from 'components/search-dropdown';
import { Partner } from '../partner/partner';
import { IPatrnerFromState, PartnerDatagrid } from './PartnerGrid';
import { IPartner } from 'types/datatypes/IPartner';

interface PartnerSearchProps {
  partner?: Partial<IPartner>;
  onPartnerClose?: ()=>void;
  onSelect: (value:IPartner)=>void;
  readOnly?: boolean;
  stylingMode?: string;
  validator?: React.ReactNode;
  [x:string]: any
}

export const PartnerSearch = (props:PartnerSearchProps) => {
  const [ partnerFormState, setPartnerFormState ] = useState<IPatrnerFromState>({
    visible: false,
    new: false,
    ref: props?.partner?.ref ?? '',
    name: props?.partner?.name ?? ''
  });

  useEffect(() => {
    setPartnerFormState((prev) => ({
      ...prev,
      ref: props?.partner?.ref ?? '',
      name: props?.partner?.name
    }));
  }, [ props?.partner ]);

  const handlePartnerClose = () => {
    setPartnerFormState((prev) => ({ ...prev, visible: false }));
    props.onPartnerClose?.();
  };


  const handleEdit = () => {
    setPartnerFormState((prev) => ({ ...prev, visible: true, new: false }));
  };

  const handleSelect = (value:IPartner) => {
    props.onSelect(value);
    setPartnerFormState((prev) => ({ ...prev, ref: value?.ref, name: value?.name }));
  };

  const handleSave = (partner:IPartner) => {
    if (partnerFormState.new) {
      handleSelect(partner);
    } else {
      setPartnerFormState((prev) => ({ ...prev, visible: false }));
    }
    props.onSelect(partner);
  };

  const popup = useMemo(() => (
    <Partner
      visible={partnerFormState.visible}
      newPartner={partnerFormState.new}
      partnerRef={partnerFormState.ref ?? ''}
      onSave={handleSave}
      onClose={handlePartnerClose}
    />
  ), [ partnerFormState ]);

  return (
    <div style={{ paddingTop: '0px', width: '100%' }}>
      <SearchDropdown
        {...props}
        value={partnerFormState.ref}
        text={partnerFormState.name}
        onSelect={handleSelect}
        onEdit={handleEdit}
        minSearchLength={3}
        searchTimeout={500}
        placeholder={props.hint}
        saveSearchValueOnLeave={true}
        width='100%'
        popupMode='popup'
        dropdownHeight={500}
        readOnly={props?.readOnly}
      >
        <PartnerDatagrid
          searchField='name'
          setPartnerFormState={setPartnerFormState}
          value={props.partnerFormState}
          onSelectionChanged={() => undefined}
        />
      </SearchDropdown>
      {partnerFormState.visible && popup}
    </div>
  );
};

